import React from 'react';
import styles from './InfoBox.module.scss';
import infoIcon from '../../../assets/icons/info-circle.svg';

const InfoBox = ({ children, message, type = 'info', large = false }) => {
  return (
    <div className={`${styles.infoBox} ${styles[type]} ${large ? styles.large : ''}`}>
      <img src={infoIcon} alt="Info" className={styles.icon} />
      <p className={styles.text}>{message || children}</p>
    </div>
  );
};

export default InfoBox;
